export default __webpack_public_path__ + "static/media/HeroImageGroup 2@2x.f6007608.png";